import React from 'react';

const GetStartedLeftText = () => {
  return (
    <>
      <div className='col-xl-6 col-lg-5 col-md-12 order-1 order-lg-0'>
        <div className='testimonial-tab-slider-wrap mt-6'>
            <h2 className='text-white'>Start Your Project with Us</h2>
          <p>
            Join thousands of users who are already processing payments using Sunlex. <br/>
            Why wait? Create your account today.
          </p>
          <p>
            Sign up now - fast and easy.
          </p>
          <hr />
          <img
              src='assets/img/cr-card.png'
              alt='testimonial'
              width='455'
              className='img-fluid rounded-circle'
          />
        </div>
      </div>
    </>
  );
};

export default GetStartedLeftText;
